import React from 'react';
import { GivelifyLabel } from '../../label';
import { useImageEditorContext } from '../context/ImageEditorContext';

export const EditorHeader: React.FC = () => {
    const { copy, isBusy, isUploading } = useImageEditorContext();
    return (
        <div className="modal-title">
            <GivelifyLabel
                text={isBusy || isUploading ? copy.title : copy.titleEdit}
                variant="heading2S"
            />
        </div>
    );
};
